<template>
  <section class="real-tasks">
    <div class="container">
      <h2 class="section-title">{{ $t('student.taskTypesTitle') }}</h2>
      <p class="section-subtitle">{{ $t('student.taskTypesDesc') }}</p>
      
      <div class="tasks-grid">
        <div class="task-card" v-for="(task, index) in tasks" :key="index">
          <div class="task-icon-container">
            <svg class="task-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <!-- Web 开发 -->
              <g v-if="task.iconType === 'web'">
                <rect x="6" y="4" width="12" height="16" rx="1" />
                <path d="M9 8h6M9 12h6M9 16h3" />
              </g>
              <!-- 数据 / AI 训练 -->
              <g v-else-if="task.iconType === 'data'">
                <rect x="3" y="5" width="3" height="11" rx="0.5" />
                <rect x="10" y="3" width="3" height="13" rx="0.5" />
                <rect x="17" y="7" width="3" height="9" rx="0.5" />
              </g>
              <!-- AI 算法 -->
              <g v-else-if="task.iconType === 'ai'">
                <circle cx="12" cy="12" r="9" />
                <circle cx="9" cy="10" r="1.5" fill="currentColor" />
                <circle cx="15" cy="10" r="1.5" fill="currentColor" />
                <path d="M9 15s1 1 3 1 3-1 3-1" />
              </g>
              <!-- 产品 / 设计 / 体验 -->
              <g v-else-if="task.iconType === 'security'">
                <path d="M4 7h16M7 4h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
                <circle cx="9" cy="11" r="1" />
                <circle cx="12" cy="11" r="1" />
                <circle cx="15" cy="11" r="1" />
              </g>
              <!-- 移动 App -->
              <g v-else-if="task.iconType === 'mobile'">
                <rect x="7" y="3" width="10" height="18" rx="2" ry="2" />
                <circle cx="12" cy="17" r="1" fill="currentColor" />
                <path d="M9 7h6" />
              </g>
              <!-- 文档 / 分析 -->
              <g v-else>
                <path d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9z" />
                <polyline points="14 2 14 9 21 9" />
                <path d="M10 13h4M10 17h2" />
              </g>
            </svg>
          </div>
          <h3>{{ task.title }}</h3>
          <p>{{ task.description }}</p>
          <div class="task-meta">{{ task.difficulty }} | {{ task.duration }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'RealTaskTypes',
  data() {
    return {
      taskTypes: [
        'taskType1',
        'taskType2',
        'taskType3',
        'taskType4',
        'taskType5'
      ]
    }
  },
  computed: {
    tasks() {
      return [
        {
          title: this.$t('student.taskType1Title'),
          description: this.$t('student.taskType1Desc'),
          difficulty: '难度: ⭐⭐⭐',
          duration: '周期: 2-4周',
          iconType: 'web'
        },
        {
          title: this.$t('student.taskType2Title'),
          description: this.$t('student.taskType2Desc'),
          difficulty: '难度: ⭐⭐⭐',
          duration: '周期: 1-3周',
          iconType: 'data'
        },
        {
          title: this.$t('student.taskType2Title'),
          description: this.$t('student.taskType2Desc'),
          difficulty: '难度: ⭐⭐⭐⭐',
          duration: '周期: 3-6周',
          iconType: 'ai'
        },
        {
          title: this.$t('student.taskType3Title'),
          description: this.$t('student.taskType3Desc'),
          difficulty: '难度: ⭐⭐⭐⭐',
          duration: '周期: 1-4周',
          iconType: 'security'
        },
        {
          title: this.$t('student.taskType4Title'),
          description: this.$t('student.taskType4Desc'),
          difficulty: '难度: ⭐⭐⭐',
          duration: '周期: 2-4周',
          iconType: 'mobile'
        },
        {
          title: this.$t('student.taskType5Title'),
          description: this.$t('student.taskType5Desc'),
          difficulty: '难度: ⭐⭐',
          duration: '周期: 1-2周',
          iconType: 'content'
        }
      ]
    }
  }
}
</script>

<style scoped>
.real-tasks {
  padding: 5rem 2rem;
  background: 
    radial-gradient(circle at 100% 0%, rgba(0, 217, 255, 0.08) 0, transparent 50%),
    radial-gradient(circle at 0% 100%, rgba(138, 43, 226, 0.08) 0, transparent 50%),
    #020617;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #00D9FF, #0066FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
  margin-bottom: 3rem;
}

.tasks-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.75rem;
}

.task-card {
  position: relative;
  padding: 2rem;
  background: #0B1220;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  transition: all 0.3s ease;
  overflow: hidden;
  cursor: pointer;
}

.task-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 0% 0%, rgba(0, 180, 255, 0.1) 0%, transparent 60%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.task-card:hover {
  border-color: rgba(255, 255, 255, 0.15);
  transform: translateY(-4px);
  background: linear-gradient(135deg, #0B1220 0%, #0F172A 100%);
}

.task-card:hover::before {
  opacity: 1;
}

/* 左边accent stripe */
.task-card::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #00D9FF 0%, #0066FF 50%, transparent 100%);
  border-radius: 16px 0 0 16px;
}

/* 图标容器 */
.task-icon-container {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
  background: rgba(0, 217, 255, 0.08);
  border: 1px solid rgba(0, 217, 255, 0.2);
  border-radius: 12px;
  color: #00D9FF;
  transition: all 0.3s ease;
}

.task-card:hover .task-icon-container {
  background: rgba(0, 217, 255, 0.15);
  border-color: rgba(0, 217, 255, 0.4);
  color: #00E5FF;
}

.task-icon {
  width: 20px;
  height: 20px;
}

.task-card h3 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #F9FAFB;
  margin-bottom: 0.75rem;
  position: relative;
  z-index: 1;
}

.task-card p {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.6;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
}

.task-meta {
  font-size: 0.85rem;
  color: rgba(0, 217, 255, 0.8);
  font-weight: 600;
  position: relative;
  z-index: 1;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 1.8rem;
  }

  .real-tasks {
    padding: 3rem 1.5rem;
  }

  .tasks-grid {
    grid-template-columns: 1fr;
  }
}
</style>
